import type { Image } from './image';
import type { KudoDataObject } from './service/kudo';
import { type UserBase, createUserBase } from './user';

export type Kudo = {
  htmlContent: string;
  id: string;
  textContent: string;
  user: KudoUser;
};

// TODO: according to open api user in kudo is specific type of user that are not specified anywhere else
export type KudoUser = { profilePhoto?: Image } & UserBase;

export const createKudoInContentObject = (data: KudoDataObject): Kudo => ({
  htmlContent: data.html_content,
  id: data.id,
  textContent: data.text_content,
  user: {
    ...createUserBase(data.user),
    profilePhoto: data.user.profile_photo,
  },
});
